import { h } from 'preact'
import Tabs from '../Tabs'
import LeaderboardUserList, {User} from './LeaderboardUserList'
import Phrase from '../../libs/translationsUtils/phrase'

export const allTimeRanges: Array<TimeRanges> = ['thisWeek', 'allTime']

export type TimeRanges = 'thisWeek' | 'allTime'

interface CustomDisplayOptions {
    maxResults: number,
    timeRange: Array<TimeRanges>,
    excludeUserRole?: Array<string>,
    emptyMessage: string,
    isPreviewEmptyMessage: boolean,
    usersList?: Array<User>,
    title: string,
    showLink?: boolean,
    linkText?: string
}

const PointsLeaderboard = (props: CustomDisplayOptions) => {
  let tabs = props.timeRange || allTimeRanges
  const tabTitles = tabs.map(tab => {
    return <Phrase p={`leaderboard.points.${tab}`} />
  })
  return (
    <div class='box widget widget--leaderboard_points qa-widget-leaderboard_points'>
      <div class='box__content box__pad'>
        {props.title ? <h3 class='widget-title'>{ props.title }</h3> : null}
        <div className='leaderboard-container'>
          <Tabs titles={tabTitles}>
            {tabs.map(tab => <LeaderboardUserList
              key={tab}
              tabTitle={tab}
              maxResults={props.maxResults}
              usersList={props.usersList}
              excludeUserRole={props.excludeUserRole ? props.excludeUserRole : []}
              emptyMessage={props.emptyMessage}
              isPreviewEmptyMessage={props.isPreviewEmptyMessage}
              showLink={props.showLink}
              linkText={props.linkText}
            />)}
          </Tabs>
        </div>
      </div>
    </div>
  )
}

export default PointsLeaderboard
